import React, { useEffect, useState } from 'react'
import axios from 'axios'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Stack,
    TextField,
    MenuItem,
    Divider,
    IconButton,
    Box,
    Typography
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import apiUrl from '../../configs/constant'
import { useToast } from '../ToastProvider'

/* ===================== STATIC OPTIONS ===================== */

const jenisAktifitas = [
    { id: '1', label: 'Kontak' },
    { id: '2', label: 'Follow Up' },
    { id: '3', label: 'Order' }
]

const jenisKontak = [
    { id: '1', label: 'Whatsapp' },
    { id: '2', label: 'Telp' },
    { id: '3', label: 'Email' },
    { id: '4', label: 'Kunjungan' }
]

/* ===================== TYPES ===================== */

interface Props {
    open: boolean
    date?: any
    onClose: () => void
    onReload: () => void
}

/* ===================== COMPONENT ===================== */

export default function ActivityScheduleDialog({ open, date, onClose, onReload }: Props) {
    const { showToast } = useToast()

    const userData = JSON.parse(localStorage.getItem('user') || '{}')
    const token = userData?.token

    const [listCustomer, setListCustomer] = useState<any[]>([])

    const [customer, setCustomer] = useState('')
    const [title, setTitle] = useState('')
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [activityType, setActivityType] = useState('')
    const [contactType, setContactType] = useState('')
    const [description, setDescription] = useState('')
    const [pic, setPic] = useState('')

    /* ===================== LOAD ACTIVITY ===================== */
    const loadCustomer = async () => {
        try {
            const res = await axios.get(
                `${apiUrl.apiUrl}/omni/chat/get-contact`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            )

            if (res.data.success) {
                setListCustomer(res.data.data)
            }
        } catch {
            showToast('Gagal mengambil catatan', 'error')
        }
    }

    useEffect(() => {
        if (open) {
            loadCustomer()

            if (date) {
                setStartDate(dateToDatetimeLocal(date))
                setEndDate(dateToDatetimeLocal(date))
            }
        }
    }, [open, date])

    const resetForm = () => {
        setCustomer('')
        setTitle('')
        setStartDate('')
        setEndDate('')
        setActivityType('')
        setContactType('')
        setDescription('')
        setPic('')
    }

    const dateToDatetimeLocal = (date?: Date) => {
        if (!date) return ''
        const pad = (n: number) => n.toString().padStart(2, '0')

        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
    }

    const convertDatetime = (value: string) => {
        if (!value) return null
        return value.replace('T', ' ') + ':00'
    }

    /* ===================== SAVE / UPDATE ===================== */
    const saveSchedule = async () => {
        try {
            const payload = {
                sdcust_id: customer,
                judul: title,
                tgl_awal: convertDatetime(startDate),
                tgl_akhir: convertDatetime(endDate),
                jenis_aktifitas: activityType,
                jenis_kontak: contactType,
                keterangan: description,
                pic
            }

            let res = await axios.post(
                `${apiUrl.apiUrl}/omni/activity/add`,
                payload,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            )

            if (res.data.success) {
                showToast('Activity ditambahkan', 'success')

                onReload()
                onClose()
                resetForm()
            }
        } catch {
            showToast('Gagal menyimpan Activity', 'error')
        }
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Jadwal Aktifitas</DialogTitle>

            <DialogContent dividers>

                {/* ===== FORM ===== */}
                <Stack spacing={2}>
                    <TextField label="Judul Aktifitas" fullWidth value={title} onChange={e => setTitle(e.target.value)} />


                    <TextField select label="Customer" fullWidth value={customer}
                        onChange={e => setCustomer(e.target.value)}>
                        {listCustomer.map(item => (
                            <MenuItem key={item.sdcust_id} value={item.sdcust_id}>{item.contact_name}</MenuItem>
                        ))}
                    </TextField>

                    <TextField
                        type="datetime-local"
                        label="Tanggal Awal"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        value={startDate}
                        onChange={e => setStartDate(e.target.value)}
                    />

                    <TextField
                        type="datetime-local"
                        label="Tanggal Akhir"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        value={endDate}
                        onChange={e => setEndDate(e.target.value)}
                    />

                    <TextField select label="Jenis Aktifitas" fullWidth value={activityType}
                        onChange={e => setActivityType(e.target.value)}>
                        {jenisAktifitas.map(item => (
                            <MenuItem key={item.id} value={item.label}>{item.label}</MenuItem>
                        ))}
                    </TextField>

                    <TextField select label="Jenis Kontak" fullWidth value={contactType}
                        onChange={e => setContactType(e.target.value)}>
                        {jenisKontak.map(item => (
                            <MenuItem key={item.id} value={item.label}>{item.label}</MenuItem>
                        ))}
                    </TextField>

                    <TextField label="PIC" fullWidth value={pic} onChange={e => setPic(e.target.value)} />

                    <TextField
                        label="Keterangan"
                        multiline
                        rows={3}
                        fullWidth
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                    />
                </Stack>
            </DialogContent>


            <DialogActions>
                <Button onClick={resetForm}>Reset</Button>
                <Button variant="contained" onClick={saveSchedule}>
                    Simpan
                </Button>
            </DialogActions>
        </Dialog >
    )
}
